import { YearMenu } from './YearMenu'
import { YearRow } from './YearRow'
import type { YearPickerProps } from './yearPick'

// Past this many years the row of buttons crowds the coverage counts off the bar.
const MOST_YEARS_IN_A_ROW = 5

export const YearPicker = (props: YearPickerProps) =>
  props.years.length > MOST_YEARS_IN_A_ROW ? (
    <YearMenu {...props} />
  ) : (
    <YearRow {...props} />
  )
